import { Box, styled, Typography } from '@mui/joy';

import { Button } from 'core/components/Button';

export const Wrapper = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 32,
});

export const LeftWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 8,
});

export const RightWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 8,
});

export const CloseSelectionButton = styled(Button)(({ theme }) => ({
  ['--IconButton-size']: '20px',
  color: theme.palette.text.primary,
  svg: {
    width: '14px',
    height: '14px',
  },
}));

export const SelectionLabel = styled(Typography)({
  fontWeight: 600,
});
